import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';
import { toastService } from '@thefarmersfront/kitchen-mobile';

import { useCodesStore } from '../../store';
import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeClusterCodesResponse = {
  code: string;
  message: string;
  data: {
    cluster: TypeCodeState[];
  };
};

/** @description 모든 클러스터 코드 조회 */
export const useGetClusterCodes = () => {
  const queryClient = useQueryClient();

  const { setClusterCodes } = useCodesStore((state) => state.actions);

  const handleSuccess = (response: TypeClusterCodesResponse) => {
    setClusterCodes(response?.data?.cluster ?? []);
  };

  const handleError = (error: TypeErrorFormat) => {
    toastService.addToast({ message: error.message });
    setClusterCodes(null);
  };

  const requestGetClusterCodes = async ({
    queryConfig,
  }: {
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeClusterCodesResponse>>, 'queryKey' | 'queryFn'>;
  } = {}) => {
    const endpoint = '/codes/cluster';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeClusterCodesResponse>>({
      queryKey: ['codes', 'cluster'],
      queryFn: () => axiosInstance.get<TypeClusterCodesResponse>(endpoint),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, handleSuccess, handleError);
  };

  return requestGetClusterCodes;
};
